import { withStyles } from '@material-ui/core';
import { TreeItem } from '@material-ui/lab';
import { TextColor } from '../../../enums';

export const StyledTreeItem = withStyles(({ spacing }) => ({
  root: {
    color: TextColor.Main,

    '& .MuiTreeItem-iconContainer': {
      width: 'fit-content',
      color: TextColor.SlateGrey
    },

    '& .MuiTreeItem-label': {
      borderRadius: 8,
      paddingLeft: 0,
      background: 'inherit !important'
    },
    '& .MuiTreeItem-content': {
      width: 'auto',
      borderRadius: 8,
      padding: spacing(1, 2, 1, 0),

      '&:hover': {
        background: '#EEF0F2'
      }
    },
    svg: {
      width: 24,
      height: 24
    },
    '&.Mui-selected > .MuiTreeItem-content': {
      background: `${TextColor.Blue} !important`,
      color: '#fff !important',

      '& svg': {
        '& path': {
          fill: '#fff'
        }
      }
    }
  }
}))(TreeItem);
